export const TileConfiguration = Object.freeze([
  {
    title: "Topographic",
    children: [
      {
        title: "iB1000",
        key: "iB1000",
        id: 4,
        format: [
          { name: "DGN v8", title: "DGN v8", undertaking: false },
          { name: "GeoTiFF", title: "GeoTiFF", undertaking: false },
          { name: "DWG", title: "DWG", undertaking: false },
          { name: "FGDB (Tiled)", title: "FGDB (Tiled)", undertaking: false },
          { name: "GML", title: "GML", undertaking: false },
          { name: "FGDB (Whole HK)", title: "FGDB (Whole HK)", undertaking: false },
        ],
      },
      {
        title: "iB5000",
        key: "iB5000",
        id: 5,
        format: [
          { name: "DGN v8", title: "DGN v8", undertaking: false },
          { name: "GeoTiFF", title: "GeoTiFF", undertaking: false },
          { name: "DWG", title: "DWG", undertaking: false },
          { name: "FGDB (Tiled)", title: "FGDB (Tiled)", undertaking: false },
          { name: "GML", title: "GML", undertaking: false },
          { name: "FGDB (Whole HK)", title: "FGDB (Whole HK)", undertaking: false },
        ],

      },
      {
        title: "iB10000",
        key: "iB10000",
        id: 6,
        format: [
          { name: "DGN v8", title: "DGN v8", undertaking: false },
          { name: "GeoTiFF", title: "GeoTiFF", undertaking: false },
          { name: "DWG", title: "DWG", undertaking: false },
          { name: "FGDB (Tiled)", title: "FGDB (Tiled)", undertaking: false },
          { name: "GML", title: "GML", undertaking: false },
          { name: "FGDB (Whole HK)", title: "FGDB (Whole HK)", undertaking: false },
        ],
      },
      {
        title: "iB20000",
        key: "iB20000",
        id: 7,
        format: [
          { name: "DGN v8", title: "DGN v8", undertaking: false },
          { name: "GeoTiFF", title: "GeoTiFF", undertaking: false },
          { name: "DWG", title: "DWG", undertaking: false },
          { name: "FGDB (Tiled)", title: "FGDB (Tiled)", undertaking: false },
          { name: "GML", title: "GML", undertaking: false },
          { name: "FGDB (Whole HK)", title: "FGDB (Whole HK)", undertaking: false },
        ],
      }
    ]
  },
  {
    title: "Land Boundary",
    children: [
      {
        title: "iC1000",
        key: "iC1000",
        id: 9,
        format: [
          { name: "DGN v8", title: "DGN v8", undertaking: false },
          { name: "DWG", title: "DWG", undertaking: false },
          { name: "FGDB (Tiled)", title: "FGDB (Tiled)", undertaking: false },
          { name: "GML", title: "GML", undertaking: false },
          { name: "FGDB (Whole HK)", title: "FGDB (Whole HK)", undertaking: false },
        ]
      }
    ]
  },
  {
    title: "Geo-Reference",
    children: [
      {
        title: "iG1000",
        key: "iG1000",
        id: 13,
        format: [
          { name: "ASCII", title: "ASCII", undertaking: false },
          { name: "FGDB (Tiled)", title: "FGDB (Tiled)", undertaking: false },
          { name: "GML", title: "GML", undertaking: false },
          { name: "DWG", title: "DWG", undertaking: false },
          { name: "DGN v8", title: "DGN v8", undertaking: false },
          { name: "FGDB (Whole HK)", title: "FGDB (Whole HK)", undertaking: false },
        ]
      }
    ]
  },
  {
    title: "Orthophoto",
    children: [
      {
        title: "DOP1000-1963P",
        key: "DOP1000-1963",
        id: 14,
        format: [
          { name: "GeoTIFF", title: "GeoTIFF", undertaking: false },
          { name: "ECW (Whole HK)", title: "ECW (Whole HK) *", undertaking: true },
          { name: "MrSID (Whole HK)", title: "MrSID (Whole HK) *", undertaking: true },
        ]
      },
      {
        title: "DOP1000-1963G",
        key: "DOP1000-1963",
        id: 14,
        format: [
          { name: "GeoTIFF", title: "GeoTIFF", undertaking: false },
          { name: "ECW (Whole HK)", title: "ECW (Whole HK) *", undertaking: true },
          { name: "MrSID (Whole HK)", title: "MrSID (Whole HK) *", undertaking: true },
        ]
      },
      {
        title: "DOP1000-1982P",
        key: "DOP1000-1982",
        id: 15,
        format: [
          { name: "GeoTIFF", title: "GeoTIFF", undertaking: false },
        ]
      },
      {
        title: "DOP1000-1982G",
        key: "DOP1000-1982",
        id: 15,
        format: [
          { name: "GeoTIFF", title: "GeoTIFF", undertaking: false },
        ]
      },
      {
        title: "DOP5000",
        key: "DOP5000",
        id: 16,
        format: [
          { name: "GeoTIFF", title: "GeoTIFF", undertaking: false },
          { name: "ECW (Whole HK)", title: "ECW (Whole HK) *", undertaking: true },
          { name: "MrSID (Whole HK)", title: "MrSID (Whole HK) *", undertaking: true },
          { name: "JPEG (DOPM50-LO Whole HK)", title: "JPEG (DOPM50-LO Whole HK)", undertaking: true },
        ]
      },
      {
        title: "DOP5000-1982",
        key: "DOP5000-1982",
        id: 16,
        format: [
          { name: "GeoTIFF", title: "GeoTIFF", undertaking: false },
        ]
      }
    ]
  },
  {
    title: "GeoCommunity",
    children: [
      {
        title: "iGeoCom",
        key: "iGeoCom",
        id: 18,
        format: [
          { name: "MDB (Whole HK)", title: "MDB (Whole HK)", undertaking: false },
          { name: "XLS (Whole HK)", title: "XLS (Whole HK)", undertaking: false },
        ]
      }
    ]
  },
  {
    title: "3D Spatial",
    children: [
      {
        title: "3D-BIT00",
        key: "3D-BIT00",
        id: 19,
        format: [
          { name: "3D Max", title: "3D Max", undertaking: false },
          { name: "3DS", title: "3DS", undertaking: false },
          { name: "VRML", title: "VRML", undertaking: false },
          { name: "FBX", title: "FBX", undertaking: false },
        ]
      }
    ]
  },

]);

export const TileLayerConfigurationURL = `${process.env.VUE_APP_LIDAR_MAP_URL}/iDMOS/MapIndex/MapServer/`;
export const TileLayerList = ["iB1000", "iB5000", "iB10000", "iB20000", "iC000", "iG1000", "DOP1000-1963P", "DOP1000-1963G", "DOP5000", "iGeoCom", "3D-BIT00"]

export const YearsRange = {
  minYear: 2019,
  maxYear: new Date().getFullYear()

}
export const OthersConfiguration = Object.freeze([
  {
    title: "Aerial Photo",
    key: "UAV (Aerial Photo)",
    id: 20
  },
  {
    title: "Aerial Video",
    key: "UAV (Aerial Video)",
    id: 21
  },
  {
    title: "Panorama",
    key: "UAV (Panorama)",
    id: 22
  },
  {
    title: "Mesh Model",
    key: "UAV (Mesh Model)",
    id: 23
  },
  {
    title: "Point Cloud Model",
    key: "UAV (Point Cloud)",
    id: 24
  },
  {
    title: "Orthophoto",
    key: "UAV (Orthophoto)",
    id: 25
  }
]);
export const OthersProductList = ["Aerial Photo", "Aerial Video", "Panorama", "Mesh Model", "Point Cloud Model", "Orthophoto"]
export const LayersList = ["iB1000", "iB5000", "iB10000", "iB20000", "iC000", "iG1000", "DOP1000-1963P", "DOP1000-1963G", "DOP1000-1982P", "DOP1000-1982G", "DOP5000", "DOP5000-1982", "3D-BIT00", "Aerial Photo", "Aerial Video", "Panorama", "Mesh Model", "Point Cloud Model", "Orthophoto"]


